import React from 'react'

const OrgChartContainer = (props) => {
  return (
    <div>
      <iframe
        title="Organization Chart"
        src="https://app.organimi.com/embed/organizations/5e3b43fe96df080015354ea0/charts/5e3b441b2e26f9001580f625/chart/view?pId=23f89d5f4b5b16b18b6841a1c5af0138dd894f32035ae6b3dac5be4e95fe91b2"
        style={{ height: '90vh', width: '100%', background: '#fff' }} 
      />
    </div>
  )
}

export default OrgChartContainer



// WEBPACK FOOTER //
// ./src/routes/org-chart/OrgChartContainer.js